import { request } from 'utils/requests'
import { cachedFetch, cacheClear } from 'utils/memoryCache'
import { CACHE_TTL } from 'utils/cacheTtl'

const PREFIX = 'settings:stages:'

export const listStages = async (params = {}) => {
  try {
    return await cachedFetch(
      `${PREFIX}list:${JSON.stringify(params)}`,
      async () => request.get('/stages', { params }),
      { ttlMs: CACHE_TTL.SETTINGS_STABLE }
    )
  } catch (error) {
    console.error('Erro ao listar etapas:', error)
    throw error
  }
}


export const getStage = async (id) => {
  try {
    return await cachedFetch(
      `${PREFIX}one:${id}`,
      async () => request.get(`/stages/${id}`),
      { ttlMs: CACHE_TTL.SETTINGS_STABLE }
    )
  } catch (error) {
    console.error('Erro ao buscar etapa:', error)
    throw error
  }
}

export const createStage = async (data) => {
  try {
    const response = await request.post('/stages', data)
    cacheClear(PREFIX)
    return response
  } catch (error) {
    console.error('Erro ao criar etapa:', error)
    throw error
  }
}


export const updateStage = async (id, data) => {
  try {
    const response = await request.put(`/stages/${id}`, data)
    cacheClear(PREFIX)
    return response
  } catch (error) {
    console.error('Erro ao atualizar etapa:', error)
    throw error
  }
}


export const deleteStage = async (id) => {
  try {
    const response = await request.delete(`/stages/${id}`)
    cacheClear(PREFIX)
    return response
  } catch (error) {
    console.error('Erro ao excluir etapa:', error)
    throw error
  }
}


export const listActiveStages = async () => {
  try {
    return await cachedFetch(
      `${PREFIX}active`,
      async () => request.get('/stages', { params: { status: 'active' } }),
      { ttlMs: CACHE_TTL.SETTINGS_STABLE }
    )
  } catch (error) {
    console.error('Erro ao listar etapas ativas:', error)
    throw error
  }
}

export const listStagesByProcessType = async (processType) => {
  try {
    return await cachedFetch(
      `${PREFIX}processType:${processType}`,
      async () => request.get('/stages', { params: { processType } }),
      { ttlMs: CACHE_TTL.SETTINGS_STABLE }
    )
  } catch (error) {
    console.error('Erro ao listar etapas por tipo de processo:', error)
    throw error
  }
}


export const searchStages = async (searchTerm) => {
  try {
    return await cachedFetch(
      `${PREFIX}search:${searchTerm}`,
      async () => request.get('/stages/search', { params: { q: searchTerm } }),
      { ttlMs: CACHE_TTL.SEARCH }
    )
  } catch (error) {
    console.error('Erro ao buscar etapas:', error)
    throw error
  }
}

// Função reorderStages removida: backend não suporta mais reordenação manual.
